// Shared helper — reads the granular "additional permissions" (the 13
// SHOW/READ/READ&WRITE roles from Settings) that get stored in
// localStorage at login, alongside loggedInRole. Used across every page
// that needs to check one of these, so the storage key and JSON parsing
// only live in one place.

export function getPermissions() {
  try {
    return JSON.parse(localStorage.getItem("additionalPermissions") || "[]");
  } catch {
    return [];
  }
}

export function hasPermission(id) {
  return getPermissions().includes(id);
}

export function hasAnyPermission(ids) {
  const perms = getPermissions();
  return ids.some((id) => perms.includes(id));
}
